enum Roles {
  Coordinador,
  Asesor,
  Estudiante,
}

export default Roles;
